import styled from "styled-components";

export const StyledEditPackageContainer = styled.div`
display: flex;
justify-content: space-between;
`;

export const StyledEditPackageServiceRow = styled.span<{ backgroundImage: string; }>`
background-image: url( ${({ backgroundImage }) => backgroundImage} );
background-position: center;
background-repeat: no-repeat;
background-size: cover;
display: inline-block;
height: 25px;
min-width: 25px;
`;

export const StyledEditPackageButtonContainer = styled.div`
margin-right: 20px;
`;

export const StyledEditPackageAmountContainer = styled.div`
display: inline-block;
width: 20px;
`;